'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    // Spark changes for GTM - GA4: BEGIN
    processInclude(require('./gtm/gtm'));
    // Spark changes for GTM - GA4: END
});
